<template>
    <div class="page reservar">
		<!-- <MenuOpcion :titulo="titulo">
            <template v-slot:content></template>
        </MenuOpcion> -->

        <section class="page-header">
            <div class="container">
                <h1 class="title text-light">RESERVAR</h1>
            </div>
        </section>

        <div class="mt-0">
			<div class="row">
				<div class="col-12 col-md-8 bg-light shadow-md rounded p-4">

					<div class="p-4 bg-white reservation-form">
                        <b-form @submit.prevent="submit">
							<div class="data-travel">

								<div class="form-group row">
                                    <div class="col-8">
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" name="opcionHotelesRutas"
                                                id="opcionHoteles" value="option1" checked disabled>
                                            <label class="form-check-label" for="opcionHoteles">Hoteles</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" name="opcionHotelesRutas"
                                                id="opcionRutas" value="option2" disabled>
                                            <label class="form-check-label" for="opcionRutas">Rutas</label>
                                        </div>
                                    </div>



                                    <div class="col-4">
                                        <b-btn @click="hotel_dispo" size='sm' class="mr-2" variant="outline-primary">Disponibilidad</b-btn>
                                        <b-link v-b-modal.infoReservar>
                                            <i class="fa fa-info-circle fa-2x"></i>
                                        </b-link>

                                    </div>
								</div>
                                <!-- hotel -->
								<div class="form-group row">
									<div class="col">
										<!-- <select class="form-control">
											<option>{{ hotel.hotel }}</option>
										</select> -->
                                        <b-form-input v-model="hotel.hotel" v-uppercase disabled/>
									</div>
								</div>
                                <!-- transporte -->
                                <div class="form-group row">
                                    <div class="col-sm-6">
                                        <b-form-input v-model="turno.sal" v-uppercase disabled/>
                                    </div>
                                    <div class="col-sm-6">
                                        <b-form-select v-model="reserva.lsa" :options="tpsal" size="md"/>
									</div>
								</div>
                                <!-- Turno Personas Seguro -->
								<div class="form-row col-12 justify-content-between">
									<div class="form-group">
										<label for="dispo" class="col-form-label">Fecha de Salida</label>
										<div class="">
											<select class="form-control" id="dispo">
												<option>{{ turno.fhe }}</option>
											</select>
										</div>
									</div>
									<div class="form-group">
										<label for="pax" class="col-sm-3 col-form-label">Personas</label>
										<div class="">
                                            <b-form-select v-model="reserva.tpp" :options="tppax" @change="calcula"
                                                size="sm" class="form-control">
                                            </b-form-select>
										</div>
									</div>
									<div class="form-group">
										<label for="seguro" class="col-form-label">Seguro / Extras</label>
										<div class="">
                                            <b-form-select v-model="reserva.seg" :options="tpseg" @change="calcula"
                                                size="sm" class="form-control">
                                            </b-form-select>
										</div>
									</div>
								</div>
							</div> <!-- Fin data travel -->

							<hr>

                            <h4 class="data-client mt-2">Datos Clientes / Huéspedes</h4>
                            <!-- Login -->
                            <div v-if="!logueado">
                                <div class="card p-3 my-3 bg-light-2">
                                    <p class="small">Si ya está registrado, inicie sesión para autocompletar sus datos
                                        personales, si es un nuevo usuario regístrese para continuar con la reserva.</p>
                                    <div>
                                        <!-- <b-link to="/login" class="mr-5 btn btn-outline-primary">Acceso Usuarios</b-link> -->
                                        <!-- <b-link to="/registro" class="mr-5 btn btn-outline-primary">Registrarme</b-link>                                     -->
                                        <b-btn @click="login_modal" class="mr-5" variant="outline-primary">Acceso Usuarios</b-btn>
                                        <b-btn @click="registro_modal" class="mr-5" variant="outline-primary">Registrarme</b-btn>

                                    </div>
                                </div>
                            </div>
                            <!-- Datos Reserva -->
                            <div v-else>
                                <div class="form-row">
                                <!-- c1 -->
                                    <b-form-group label="Sr/Sra." class="col-auto">
                                        <b-form-select v-model="reserva.c1.sra">
                                            <b-form-select-option value='0'>Sr.</b-form-select-option>
                                            <b-form-select-option value='1'>Sra.</b-form-select-option>
                                        </b-form-select>
                                    </b-form-group>
                                    <b-form-group label="Apellidos" class="col-sm-4">
                                        <b-form-input v-model="reserva.c1.ape" v-uppercase required trim></b-form-input>
                                    </b-form-group>
                                    <b-form-group label="Nombre" class="col-sm-2">
                                        <b-form-input v-model="reserva.c1.nom" v-uppercase required trim></b-form-input>
                                    </b-form-group>
                                    <b-form-group label="DNI/NIF" class="col-sm-2">
                                        <b-form-input v-model="reserva.c1.nif" ref='dni' required trim @blur="valida_dni(reserva.c1.nif)"></b-form-input>
                                    </b-form-group>
                                    <b-form-group label="Año Nacim." class="col-sm-2">
                                        <b-form-input v-model.number="reserva.c1.nac" v-numero maxlength="4"></b-form-input>
                                    </b-form-group>
                                </div>
                                <!-- c2 -->
                                <div class="form-row" v-show="reserva.pax>1">
                                    <b-form-group label="" class="col-auto">
                                        <b-form-select v-model="reserva.c2.sra">
                                            <b-form-select-option value=0>Sr.</b-form-select-option>
                                            <b-form-select-option value=1>Sra.</b-form-select-option>
                                        </b-form-select>
                                    </b-form-group>
                                    <b-form-group label="" class="col-sm-4">
                                        <b-form-input v-model="reserva.c2.ape" v-uppercase trim :required="reserva.pax>=2"></b-form-input>
                                    </b-form-group>
                                    <b-form-group label="" class="col-sm-2">
                                        <b-form-input v-model="reserva.c2.nom" v-uppercase trim :required="reserva.pax>=2"></b-form-input>
                                    </b-form-group>
                                    <b-form-group label="" class="col-sm-2">
                                        <b-form-input v-model="reserva.c2.nif" ref='dni' trim :required="reserva.pax>=2" @blur="valida_dni(reserva.c2.nif)"></b-form-input>
                                    </b-form-group>
                                    <b-form-group label="" class="col-sm-2">
                                        <b-form-input v-model.number="reserva.c2.nac" v-numero maxlength="4"></b-form-input>                                   </b-form-group>
                                </div>
                                <!-- c3 -->
                                <div class="form-row" v-show="reserva.pax>2">
                                    <b-form-group label="" class="col-auto">
                                        <b-form-select v-model="reserva.c3.sra">
                                            <b-form-select-option value=0>Sr.</b-form-select-option>
                                            <b-form-select-option value=1>Sra.</b-form-select-option>
                                        </b-form-select>
                                    </b-form-group>
                                    <b-form-group label="" class="col-sm-4">
                                        <b-form-input v-model="reserva.c3.ape" v-uppercase trim :required="reserva.pax>=3"></b-form-input>
                                    </b-form-group>
                                    <b-form-group label="" class="col-sm-2">
                                        <b-form-input v-model="reserva.c3.nom" v-uppercase trim :required="reserva.pax>=3"></b-form-input>
                                    </b-form-group>
                                    <b-form-group label="" class="col-sm-2">
                                        <b-form-input v-model="reserva.c3.nif" ref='dni' trim :required="reserva.pax>=3" @blur="valida_dni(reserva.c3.nif)"></b-form-input>
                                    </b-form-group>
                                    <b-form-group label="" class="col-sm-2">
                                        <b-form-input v-model.number="reserva.c3.nac" v-numero maxlength="4"></b-form-input>
                                    </b-form-group>
                                </div>
                                <!-- c4 -->
                                <div class="form-row" v-show="reserva.pax>3">
                                    <b-form-group label="" class="col-auto">
                                        <b-form-select v-model="reserva.c4.sra">
                                            <b-form-select-option value=0>Sr.</b-form-select-option>
                                            <b-form-select-option value=1>Sra.</b-form-select-option>
                                        </b-form-select>
                                    </b-form-group>
                                    <b-form-group label="" class="col-sm-4">
                                        <b-form-input v-model="reserva.c4.ape" v-uppercase trim></b-form-input>
                                    </b-form-group>
                                    <b-form-group label="" class="col-sm-2">
                                        <b-form-input v-model="reserva.c4.nom" v-uppercase trim></b-form-input>
                                    </b-form-group>
                                    <b-form-group label="" class="col-sm-2">
                                        <b-form-input v-model="reserva.c4.nif" ref='dni' trim @blur="valida_dni"></b-form-input>
                                    </b-form-group>
                                    <b-form-group label="" class="col-sm-2">
                                        <b-form-input v-model.number="reserva.c4.nac" v-numero maxlength="4"></b-form-input>
                                    </b-form-group>
                                </div>
                                <!-- Localidad Residencia  -->
                                <div class="form-row">
                                    <b-form-group label="Localidad de Residencia" class="col-sm-7">
                                        <b-form-input v-model="reserva.pob" v-uppercase required trim></b-form-input>
                                    </b-form-group>
                                    <b-form-group label="Provincia" class="col-sm-5">
                                        <b-form-input v-model="reserva.pro" v-uppercase trim></b-form-input>
                                    </b-form-group>
                                </div>
                                <!-- Datos Contacto -->
                                <div class="d-flex mt-1 text-bold">
                                    <h6>Datos de Contacto</h6>
                                    <!-- <small class="ml-auto">*Datos Obligatorios</small> -->
                                </div>
                                <div class="form-row">
                                    <!-- <b-form-group label="Teléfono Movil" class="col-sm-4">                             -->
                                        <b-input-group class="my-1 col-sm-4">
                                            <b-input-group-prepend is-text>
                                                <b-icon-telephone-fill/>
                                            </b-input-group-prepend>
                                            <b-form-input required v-numero maxlength="9" v-model="reserva.tfno"></b-form-input>
                                        </b-input-group>
                                    <!-- </b-form-group>            -->
                                    <!-- <b-form-group label="eMAIL" class="col-sm-8"> -->
                                        <b-input-group class="my-1 col-sm-8">
                                            <b-input-group-prepend is-text>
                                                <b-icon-envelope/>
                                            </b-input-group-prepend>
                                            <b-form-input type="email" v-model="reserva.email"></b-form-input>
                                        </b-input-group>
                                    <!-- </b-form-group>                                    -->
                                </div>
                                <hr>
                                <!-- Observaciones  -->
                                <div class="more-data">
                                    <div class="form-group">
                                        <label for="observations" class="col-sm-2 col-form-label">Observaciones</label>
                                        <textarea class="form-control" cols="30" rows="2" v-model="reserva.obs"/>
                                    </div>
                                </div>
                                <!--Reservar-->
                                <div class="form-inline pt-1">
                                    <b-form-checkbox v-model="reserva.chk">Acepta
                                        <router-link to="/politica" class="pl-2"> Política de Privacidad</router-link>
                                    </b-form-checkbox>

                                    <b-button type="submit" variant="success" class="ml-auto my-3 my-sm-0 px-5">RESERVAR</b-button>

                                </div>
                                <div>
                                    <b-form-invalid-feedback :state="!chk_selected">
                                        <b-alert variant="danger" show>Debes Aceptar Politica de Privacidad</b-alert>
                                    </b-form-invalid-feedback>
                                </div>
                            </div>
						</b-form>
						<div class="info-rgpd p-2 mt-3">
							<p><small><strong>INFORMACIÓN BÁSICA SOBRE PROTECCIÓN DE DATOS</strong> <br>
									<strong>Responsable:</strong> VIAJES CEMO S.A.
									<strong>Finalidad:</strong> Gestionar la solicitud de reserva que realizas en este
									formulario. <br>
									<strong>Legitimación:</strong> Consentimiento del interesado. <br>
									<strong>DESTINATARIOS:</strong> No se cederán a terceros salvo obligación legal.
									<br>
									<strong>DERECHOS:</strong> Puedes ejercitar en cualquier momento tus derechos de
									acceso, rectificación, supresión, oposición y demás derechos legalmente establecidos
									a través del siguiente e-mail: info@especialvacaciones.com. <br>
									<strong>INFORMACIÓN ADICIONAL:</strong> Puedes consultar la información adicional y
									detallada sobre protección de datos
                                        <!-- <router-link to="/politica" class="pl-2"> aquí.</router-link> -->
                                     <a href="/politica">
										aquí.</a></small></p>
						</div>
					</div>
				</div>

            <!-- (derecha) info viaje -->
				<aside class="col-12 col-md-4 p-4">
					<div class="card">
						<h5 class="card-header list-group-item-primary"><i class="fas fa-list-alt"></i> Resumen Reserva</h5>
						<div class="card-body">
							<h5 class="card-title pl-2 pt-2">{{ hotel.hotel }}</h5>
							<img class="img-fluid m-0" :src="imgUrl()">
						</div>
						<div class="p-2 text-right list-group-item-primary">
                             <!-- <div class="col-1">
                                <b-link @click="ayuda(1)">
                                    <i class="fa fa-info-circle fa-2x"></i>
                                </b-link>
                            </div> -->
                            <!-- <b-button class="mr-3" variant="outline-primary"
                                v-b-modal.modal_precios>Turnos y Precios</b-button> -->
                            <b-button class="mr-3" variant="outline-primary" @click="hotelPrecios_modal">
                                Turnos y Precios
                            </b-button>
                            Total a Pagar:
                            <span class="h2 ml-3">{{ reserva.tot }} €</span>
                        </div>
						<ul class="list-group list-group-flush">
							<li class="list-group-item">
                                Fecha Salida: <strong>{{turno.fhe}} </strong> &nbsp;
                                Regreso: <strong>{{turno.fhs}}</strong> </li>
							<li class="list-group-item">Duración: <strong>{{xdiasnoc}}</strong></li>
							<li class="list-group-item">Pasajeros: <strong>{{ reserva.pax+' ('+reserva.tpp+')' }} </strong></li>
							<li class="list-group-item">
                                Precio x Persona: <strong>{{ this.turno.pre }} €</strong>
                                Sup.Indiv.: <strong>{{ this.turno.supi }} €</strong>
                            </li>
                            <li class="list-group-item">
                                <div v-show="IMP.seg[1]>0">Seguro Anulación: <strong>{{turno.segA}} €</strong></div>
                                <div v-show="IMP.seg[2]>0">Seguro Asistencia Plus + Anulación: <strong>{{turno.segC}} €</strong></div>
                            </li>
						</ul>

						<ul class="list-group list-group-flush pt-2">
							<li class="list-group-item list-group-item-primary"><span class="pr-2"><i
										class="fas fa-bed"></i></span>Habitaciones</li>
							<li class="list-group-item"> <strong>{{ xTph }}</strong>
                                <span class="ml-2" v-show="reserva.pax==1">Uso individual</span>
                                <span class="ml-2" v-show="reserva.pax>=3">(Triple)</span>
                            </li>
						</ul>
						<ul class="list-group list-group-flush pt-2">
							<li class="list-group-item list-group-item-primary"><span class="pr-2">
                                <i class="fas fa-utensils"></i></span>Servicios</li>
							<li class="list-group-item"> <strong>{{ xReg }}</strong>
								<p class="mt-2 mb-0">
                                    <span class="d-table-cell font-italic"> - Primer servicio:</span>
                                    <span class="d-table-cell  font-weight-bold pl-2">{{ turno.Cent }}</span></p>
								<p class="mt-1 mb-0">
                                    <span class="d-table-cell  font-italic"> - Último servicio:</span>
                                    <span class="d-table-cell font-italic font-weight-bold pl-2">{{ turno.Csal }}</span></p>
							</li>
							<li class="list-group-item">
								<p class="mt-2 mb-0">
                                    <span class="d-table-cell font-italic"> - Incluido:</span>
                                    <span class="d-table-cell  font-weight-bold pl-2">{{ turno.desIN }}</span></p>
								<p class="mt-1 mb-0">
                                    <span class="d-table-cell  font-italic"> - No incluido:</span>
                                    <span class="d-table-cell font-weight-bold pl-2">{{ turno.desNO }}</span></p>
							</li>

						</ul>
						<ul class="list-group list-group-flush pt-2">
							<li class="list-group-item list-group-item-primary"><span class="pr-2"><i
										class="fas fa-bus"></i></span>Transporte</li>
							<li class="list-group-item"> <strong>{{ reserva.sal }}</strong></li>

						</ul>
					</div>
				</aside>
			</div>

		</div>

        <!-- Modal infoReservar -->
        <b-modal id="infoReservar" class="modal-dialog modal-lg modal-dialog-centered"
            ok-only title="AYUDA - Como hacer una Reserva">

            <div class="m-3 p-3 border border-info">
                <ol class="p-3">
                    <li>Seleccione la Ruta o Estancia en hotel que desea reservar.</li>
                    <li>Seleccione la fecha de salida con plazas disponibles.</li>
                    <li>Selecciona el número de personas. </li>
                    <li>Regístrese o inicie sesión con su usuario y contraseña</li>
                    <li>Importante el télefono móvil y un email válido para poder
                        localizarle.
                    </li>
                </ol>
            </div>
        </b-modal>


        <!-- Modal Login -->
        <!-- <hotelPrecios/> -->

	</div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';

// import MenuOpcion from '@/components/MenuOpcion.vue'
//import hotelPrecios from '@/components/HotelPrecios.vue'

export default {
    name: 'reservar',
    components: {
        // MenuOpcion,

        //hotelPrecios,
    },
    data() {
        return {
            modulo: 'Reservas',
            titulo: 'RESERVAR',

            submitted: false,

            reserva: {
                turno: 0,
                tpp: '20',
                pax: 2,
                tot: 0,
                seg: 0,
                c1: {}, c2: {}, c3: {}, c4: {},
                tfn: '', ema: '',
                tra: 0,
                lsa: 0,
                chk: false,
            },
            tppax: [
                { value:'20', id:'2A', text:'2 Adultos', pax: 2 },
            ],
            tpseg: [
                { value:0, text:'Selecciona Opción' },
            ],
            tpsal: [
                { value:0, text:'* Sin Transporte - Salida' },
            ],
            //arrays
            tipohab: [ '','Individual','Doble','Triple', 'Cuadriple'],
            regimen: [ '','Solo Alojamiento','Alojamiento y Desayuno','Media Pensión', 'Pensión Completa'],

        }
    },
    computed: {
         ...mapState(['G','auth','errores']),

        logueado() {
            return this.auth.logueado;
        },
        cta() {
            return this.auth.user;
        },
        hotel() {
            return this.$store.state.hoteles.hotel;
        },
        turnos() {
            return this.$store.state.hoteles.turnos.items;
        },
        turno() {
            return this.$store.state.hoteles.turno;
        },
        // servicio
        xdiasnoc() {
            return String(Number(this.turno.noc)+1)+" dias "+String(this.turno.noc)+" noches";
        },
        xTph() {
            return "Habitación Doble";
        },
        xReg() {
            return this.regimen[this.turno.reg];
        },
        IMP() {
            return { pre:this.$util.SN(this.turno.pre), supi:this.$util.SN(this.turno.supi)
                ,d1n:this.$util.SN(this.turno.d1n), d2n:this.$util.SN(this.turno.d2n)
                ,d3p:this.$util.SN(this.turno.d3p), d4P:this.$util.SN(this.turno.d4p)
                ,seg:[0,this.$util.SN(this.turno.segA),this.$util.SN(this.turno.segC)],
            };
        },

        chk_selected() {
            return this.submitted && !this.reserva.chk;
        }
    },
    watch: {
        reserva: {
            handler: function (val) {
                console.log("* reservar.reserva", val);

            },
            deep: true
        },
        //turno (item , old) {
        turno () {
            this.seleccionado();
        },
        cta(item) {
            this.datos_cuenta(item);
        },


    },
    methods: {
        ...mapMutations(['loading','alerta','modal']),
        ...mapActions(['exec','error']),

        async submit(evt) {
            evt.preventDefault();
            this.submitted=true;
            if (!this.reserva.chk) return;

            //validar dnis y demas datos ???
            if (!this.validar()) return;

            //Preguntar
            let msg="Estas seguro <b>RESERVA</b> ?<br><br>"+
                "Hotel: <b>"+this.hotel.hotel+"</b><br>Periodo: <b>"+this.turno.fhe+" - "+this.turno.fhs+"</b><br>Personas: <b>"+this.reserva.pax+"</b><br>"+
                "Importe: <b>"+this.reserva.tot+" </b>€<br><br>" +
                "<b>Atención</b><br>Tras aceptar la Reserva deberá dirigirse al Apartado de Reservas, dentro de ACCESO para su gestión.<br> " +
                "Aseguresé que su navegador permite ventanas emergentes."

            if (!await this.$root.$msgConf(msg,'RESERVA'))  return;

            this.enviar();
        },
        async enviar() {
            this.loading();
            var args=this.reserva;          //token y reserva
            args.sid=this.auth.token
            let r=await this.exec({api:'reservar', arg: args });
            this.loading(false);

            if (await this.error({r})) return;

            this.submitted=false;

            let m=(r.error ? r.datos : 'Petición/Reserva Nº ' + r.datos + 'guardada correctamente');
            this.modal({tit: this.modulo, msg: m}); //, time:0});

            if (r.error) return;

            this.reserva.id=r.datos; // localizador
            this.$router.push({name:'info-personal', params: {tab: 2}});
        },

        validar() {
            let R=this.reserva;
            let m='';

            if (this.tpsal.length>1 && R.lsa==0) {
                m="Debes seleccionar una salida de BUS para el Transporte";
                /* this.modal({tit: this.modulo, msg: m, time:0});
                this.$nextTick(() => {
                    document.querySelector('select[data-vv-as="tpsal"]')?.focus();
                });
                return false; */
            }
            // añadir nif

            //if (R.tfno.length<9 || !(String(R.tfno).substr(0,1)>='9' || String(R.tfno).substr(0,1)=='6'))
            if (R.tfno.length<9 || !(String(R.tfno).substr(0,1)>='6' && String(R.tfno).substr(0,1)<='9'))
                m="Debes Introducir un Teléfono Valido del CLIENTE para la gestión de la Reserva";

            if (m>'') this.modal({tit: this.modulo, msg: m, time:0});
            return (m=='');
        },

        async msgBanco(r) {

            this.pagoBanco();

            let msg=r.error ? r.datos :
                '<span class="text-justify">'+
                'Su Petición de Reserva Nº <b>'+this.reserva.id+'</b> se ha generado correctamente.<br><br>'+
                'Se ha procedido al pago con tarjeta de credito de <h3>'+this.reserva.tot+' €</h3><br>'+
                'En este proceso se ha abierto una nueva ventana de nuestro banco donde le solicitara de forma segura los datos de pago.<br>'+
                'En caso de no finalizar el proceso lo podra volver a iniciar en el apartado de reservas de la información personal, la petición de reserva tiene una caducidad de 30 minutos para activar de nuevo el proceso de pago.<br><br>'+
                'Si completa el proceso, ya dispondrá de su/s bonos correspondientes para los servicios contratados.<br>'+
                '<b><i>Importante:</b></i><br><small>Asegurese que su navegador permite ventanas emergentes (popup).</small>'+
                '</span>' ;
            //this.modal({tit:"Reserva", msg:msg,time:0});

            await this.$root.$msgBox(msg, this.modulo);

            //this.loading(false);
            //this.$router.push('/');
        },

        pagoBanco() {
            let url=this.G.url_tpv;
            let arg=new Date().getTime()+'|5.'+this.reserva.id+'|'+this.reserva.tot;

            window.open(url+'?w='+arg,"_blank");
        },


//////////////////////////////////////////
        login_modal_store() {
            this.$store.commit("showModal",'Login');
        },
        login_modal() {
            this.$bvModal.show("modal_login");
        },
        registro_modal() {
            this.$bvModal.show("modal_registro");
        },
        hotelPrecios_modal() {
            this.$root.$hotelPrecios();
            //this.$bvModal.show("modal_hotelPrecios");
        },

        // imagenes datos hotel-turno
        imgUrl(){
            let url=this.G.url_img+"?w=123|vc_agencias|hoteles_img|||"+this.hotel.hot;
            return url;
        },

        // turno seleccionado
        seleccionado() {
            this.reserva.turno=this.turno.id;
            this.tipopax();
            this.tiposeg();
            //this.reserva.tra=this.turno.tra;
            this.salidas();

            //calculamos reserva
            this.calcula();

            //datos cuenta
            if (this.cta.ape!=this.reserva.c1.ape) this.datos_cuenta(this.cta);
            //console.log("* reservar.seleccionado",this.reserva,this.tppax,this.tpseg);
        },
        tipopax() {
            //this.turno.tpp='0013';
            if (!this.turno.tpp) this.turno.tpp="0022";
            let p=this.turno.tpp.split('');

            let min= p[0]; if (min ==undefined || min==0) min=0;
            let max= p[1]; if (max ==undefined || max==0) max=0;
            let minA=p[2]; if (minA==undefined || minA==0 || minA<min ) minA=min;
            let maxA=p[3]; if (maxA==undefined || maxA==0 || maxA<max ) maxA=max;

            this.tppax=[];
            for (let i=minA;i<=maxA;i++) {
                let pp =i+'A';
                let ppp=i+' Adulto'+(i>1?'s':'');
                this.tppax.push({id:pp, value:String(i*10), text:ppp, pax:i});

                for (let j=1;j<max;j++) {
                    let s=Number(i)+Number(j);
                    if (s>max) continue;
                    let nn=j+'N';
                    let nnn=j+' Niño'+(j>1?'s':'');
                    this.tppax.push({id:pp+nn, value:String(i*10+j), text:ppp+" "+nnn, pax:s});
                }
            }
        },
        tiposeg() {
            this.tpseg=[{value:0, text:'Selecciona Opción (Precio x Persona) ' }];
            if (this.$util.SN(this.turno.segA)>0)
                this.tpseg.push({value:1, text: "Seguro de Anulación ("+this.turno.segA+" €)"});
            if (this.$util.SN(this.turno.segC)>0)
                this.tpseg.push({value:2, text: "Seguro Asistencia Plus + Anulación ("+this.turno.segC+" €)"});
            //extras ??

        },
        salidas() {
            console.log('*************reservar.salidas',this.turno.sal);
            if (this.turno.sal=='*SIN TRANSPORTE') {
                this.reserva.tra=this.reserva.lsa=0;
                this.tpsal=[{value:0, text: "" }];
                return;
            }
            this.reserva.tra=1;
            this.reserva.lsa=0;
            let S=this.turno.salidas.split('\r\n');
            let i=1; let A=[]
            S.forEach(function(item) {
                if (item!='') {
                    console.log(item);
                    A.push({value: i, text: item + ' - ' + i });
                    i++;
                }
            });
            this.tpsal=A;
            //for (let i=1;j<max;j++) {

            // añadimos selecciona para obligarlos a seleccionar antes de guardar
            if (i>1) this.tpsal.unshift({value:0, text: "Selecciona Salida BUS"});

            console.log('*************reservar.salidas',S,i,this.tpsal);
        },
    // calculo reserva
        calcula() {
            let adu=Number(this.reserva.tpp.charAt(0));
            let nin=Number(this.reserva.tpp.charAt(1));
            let pax=adu+nin;
            let P=this.IMP;
            let sup=0;
            let dto=0;
            let ext=0;
            let imp=pax*P.pre;

            //suplementos
            if (pax==1 && P.supi>0) sup+=P.supi;  //individual

            //descuentos
            if (nin>0 && P.d1n!=0) dto+=(P.d1n<0 ? this.$util.round((-P.d1n)*P.pre/100): P.d1n);
            if (nin>1 && P.d2n!=0) dto+=(P.d2n<0 ? this.$util.round((-P.d2n)*P.pre/100): P.d2n)*(nin-1);
            if (adu>2 && P.d3p!=0) dto+=(P.d3p<0 ? this.$util.round((-P.d3p)*P.pre/100): P.d3p);
            if (adu>3 && P.d4p!=0) dto+=(P.d4p<0 ? this.$util.round((-P.d4p)*P.pre/100): P.d4p)*(adu-3);

            //seguro
            if (this.reserva.seg>0) ext+=pax*P.seg[this.reserva.seg];
            //extras

            this.reserva.pax=pax;
            this.reserva.tot=imp+sup-dto+ext;
            //console.log('* reservar.calcula',pax,this.reserva);
        },

        datos_cuenta(C) {
            this.reserva.c1={
                sra:C.sra, ape:C.ape, nom:C.nom, nif:C.nif, nac:C.nac, cpo:C.cpo,
            };
            this.reserva.pob=C.pob; this.reserva.pro=C.pro;
            this.reserva.ema=C.email;
            this.reserva.tfn=C.tfno;
        },

        //validar (pasarlo a utilidades)
         valida_dni(dni) {
             console.log(dni);
             return true;
            /* let r=this.$util.validaCIF(dni);
            if (!r) {
                //this.$refs.dni.focus();
                alert('CIF Invalido ' + r);
            } */
        },

        //
        ayuda(p=0) {
            console.log(p);
            /* var tit="Ayuda";
            var msg='';
            if (p==1) msg="Hola <b>Capullo</b><br>Adiossss";
            this.$root.$toast(msg,tit); */
        },

        //
        // async hotel_precios() {
            //await this.$store.dispatch('hotel_precios',this.hotel);
        hotel_dispo() {
            this.$bvModal.show("modal_hotelDispo");
        },
    },
    created() {
        if (this.turno.id==undefined) {
            this.$router.push('/hoteles');
        }
        //console.log('*reservar.created',this.hotel.hot,this.hotel.imagenes,this.turno.id);
    },
    mounted() {

        //turno seleccionado
        this.seleccionado();

        //datos omision cliente
        this.datos_cuenta(this.cta);
    }
}
</script>